
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const DeleteButton = (deleteHandler) => {
    return (
      <IconButton onClick={deleteHandler} color="secondary"><DeleteIcon /></IconButton>
    );
  }